/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';

import FD from '../../RestAPI/fetchData';
// import { showFailure } from '../../common/toast';
import language from '../../../assets/languages/language';
import { showFailure, showSuccess } from '../../../common/toast';
import StatusChangeModel from '../../Common/StatusChangeModel';
import AppRoutes from '../../config/AppRoutes';
import App_data from '../../config/App_data';
import DisplayLoader from './Layout/DisplayLoader';
import Heading from './Layout/Heading';
import ViewAnswer from './Layout/ViewAnswer';
import ViewCase from './Layout/ViewCase';
import ViewQuestions from './Layout/ViewQuestions';

export class CaseQuestions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      caseQuestions: [],
      cases: [],
      displayLoader: true,
      idname: '',
      token: '',
      justification1: '',
      justification2: '',
      selectedChoice: '',
      selectedIndex: -1,
      displayError: false,
      displayQuestionLoader: false,
      stopTimer: false,
      userGrading: 'Select grading',
      disableNavigationButtons: false,
      report_block: 'card hide_block',
      successAlert: false,
      reportLoading: false,

      showComponent: [1, 2],
      showLoaderOnModel: true,
      userStats: [],
      markAsCompleted: false,
      markAsNotCompleted: false,
      markCompleted: true,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      errorMessageOnValidate: '',
    };
    this.attemptedQuestions = [];
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    if (localStorage.getItem('attemptedQuestions'))
      this.attemptedQuestions = JSON.parse(localStorage.getItem('attemptedQuestions'));

    const {
      params: { caseId = 1, chapterID = 1 },
    } = this.props;
    const data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      caseId,
      chapterId: chapterID,
    };
    this.getCaseQuestions(data);
    this.getCases(data);
  }

  getNextCase = () => {
    const nextIndex = this.changeIndexInParam(1, 'case');
    if (nextIndex) {
      this.refetchAndSetCaseQuestions(nextIndex);
      this.attemptedQuestions = [];
    }
  };

  getPreviousCase = () => {
    const prevIndex = this.changeIndexInParam(-1, 'case');
    if (prevIndex > -1) {
      this.refetchAndSetCaseQuestions(prevIndex);
      this.attemptedQuestions = [];
    }
  };

  refetchAndSetCaseQuestions = index => {
    const { idname, token, cases } = this.state;
    const data = {
      idname,
      token,
      caseId: cases[index].id,
    };
    this.getCaseQuestions(data);
  };

  getPreviousQuestion = () => {
    this.changeIndexInParam(-1, 'question');
  };
  getFavQuestion = async (questionIndex = 0) => {
    //Api to Fetch saved question stats
    const { state, props } = this;
    const { idname, token, caseQuestions } = state;
    const {
      params: { chapterID },
    } = props;
    // console.log({ questionIndex });
    const isEssayQuestion = 1;
    const question_id = caseQuestions[questionIndex];
    const data = {
      idname,
      token,
      essayQuestionIndex: questionIndex,
      isEssayQuestion,
      question_id: question_id.id,
      chapter_id: chapterID,
    };
    const getQuestionIndex = this.attemptedQuestions.findIndex(
      element => element.questionId === question_id.id,
    );

    if (getQuestionIndex !== -1) {
      const {
        userGrading,
        selectedChoice,
        justification1,
        justification2,
        stopTimer,
        selectedIndex,
        disableNavigationButtons,
      } = this.attemptedQuestions[getQuestionIndex];
      this.setState(
        {
          userGrading,
          selectedChoice,
          justification1,
          justification2,
          stopTimer,
          selectedIndex,
          disableNavigationButtons,
          showResult: true,
        },
        () => {
          // console.log('check stop timer in callBack', this.state.stopTimer);
        },
      );
    }
    FD.callAPI(`${App_data.backend_api}/cfa_3question_bank/getFavQuestions`, data).then(
      response => {
        if (response.success) {
          // console.log('I am inside getSave Question');
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
          });
        } else {
          this.setState({
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            bookmarkColor: '',
          });
        }
      },
    );
  };

  unSaveQuestion = async data => {
    FD.callAPI(`${App_data.backend_api}/cfa_3question_bank/unsaveQuestion`, data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
          bookmarkColor: '',
          save_text: `${language.LC().SAVE_QUESTION}`,
        });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };
  getSummary = async () => {
    const { caseQuestions, token, idname } = this.state;

    const { questionIndex = 0 } = this.props.params;
    const { case_id } = caseQuestions[questionIndex];
    const data = {
      token,
      idname,
      caseId: case_id,
    };

    this.setState({
      change_status: true,
      changeStatusTitle: 'View Summary',
      showLoaderOnModel: true,
    });
    const result = await FD.callAPI(`${App_data.backend_api}/cfa3EssayQuestions/getSummary`, data);
    if (result.success) {
      const { userStats } = result;
      this.setState({
        userStats,
        showLoaderOnModel: false,
      });
    } else {
      this.setState({
        change_status: true,
      });
      showFailure('Something went wrong');
    }
  };

  markCompleted = () => {
    this.setState({
      markAsCompleted: true,
      markAsNotCompleted: false,
      markCompleted: false,
    });
  };

  markNotCompleted = () => {
    this.setState({
      markAsCompleted: false,
      markAsNotCompleted: true,
      markCompleted: false,
    });
  };

  changeCompletionStatus = async () => {
    const {
      state: { markAsCompleted, token, idname, cases },
      props: {
        params: { caseIndex = 0 },
      },
    } = this;
    const caseData = cases[caseIndex];
    const { chapter_id, id } = caseData;
    const data = {
      idname,
      token,
      chapterNo: chapter_id,
      caseNo: id,
      status: markAsCompleted ? 1 : 0,
    };
    await FD.callAPI(`${App_data.backend_api}/cfa3EssayQuestions/upsertUserStats`, data).then(
      () => {
        this.setState({ change_status: false });
        this.getNextCase();
      },
    );
  };

  getNextQuestion = () => {
    const result = this.changeIndexInParam(1, 'question');
    const { caseQuestions } = this.state;
    if (result === -1 && this.attemptedQuestions.length === caseQuestions.length) {
      this.getSummary();
    }
  };

  changeIndexInParam = (value, section) => {
    const {
      props: { params },
      state: { caseQuestions, cases },
    } = this;
    const { caseId, caseIndex, chapterID, chapterName, questionIndex } = params;

    let currentArray = cases;
    let currentIndex = caseIndex;

    if (section === 'question') {
      currentArray = caseQuestions;
      currentIndex = questionIndex;
    }
    const condition =
      value === -1
        ? parseInt(currentIndex, 10) > 0
        : parseInt(currentIndex, 10) < currentArray.length - 1;
    if (condition) {
      let newQuestionIndex =
        section === 'question' ? parseInt(questionIndex, 10) + value : questionIndex;
      let newCaseIndex = caseIndex;
      if (section === 'case') {
        newCaseIndex = section === 'case' ? parseInt(caseIndex, 10) + value : caseIndex;
        newQuestionIndex = 0;
      }

      this.context.router.push({
        pathname: AppRoutes.CFA3_ESSAY_QUESTION_CASE_VIEW.replace(':caseId', caseId)
          .replace(':chapterName', chapterName)
          .replace(':chapterID', chapterID)
          .replace(':questionIndex', newQuestionIndex)
          .replace(':caseIndex', newCaseIndex),
      });
      this.setState(
        {
          justification1: '',
          justification2: '',
          selectedChoice: '',
          showResult: false,
          selectedIndex: -1,
          displayError: false,
          stopTimer: false,
          disableNavigationButtons: false,
          userGrading: 'Select grading',
        },
        () => {
          if (section === 'question') this.getFavQuestion(newQuestionIndex);
        },
      );
      return section === 'case' ? newCaseIndex : newQuestionIndex;
    } else return -1;
  };

  getCaseQuestions = async data => {
    this.setState({
      displayQuestionLoader: true,
    });
    const response = await FD.callAPI(
      `${App_data.backend_api}/cfa3EssayQuestions/getQuestionsByCaseId`,
      data,
    );
    try {
      const { success, caseQuestions } = response;
      if (success) {
        const { questionIndex } = this.props.params;
        this.setState({ ValidToken: true, caseQuestions });
        this.getFavQuestion(questionIndex);
      } else {
        this.setState({
          ValidToken: false,
        });
      }
    } catch (error) {}
    this.setState({
      displayLoader: false,
      displayQuestionLoader: false,
    });
  };

  getCases = async data => {
    const getCases = await FD.callAPI(
      `${App_data.backend_api}/cfa3EssayQuestions/getCasesByChaptersId`,
      data,
    );
    const { success } = getCases;
    if (success) {
      this.setState({
        ValidToken: true,
        cases: getCases && getCases.cases,
      });
    } else {
      this.setState({
        ValidToken: false,
        errorMessage: getCases && getCases.message,
      });
    }
    this.setState({
      displayLoader: false,
    });
  };

  setJustification = event => {
    const {
      target: { value, name },
    } = event;
    this.setState({
      [name]: value,
      displayError: false,
    });
  };

  setUserChoice = (value, index) => {
    this.setState({
      selectedChoice: value,
      selectedIndex: index,
      displayError: false,
    });
  };

  upsertQuestionUserStats = async () => {
    const {
      idname,
      token,
      justification1,
      justification2,
      selectedChoice,
      userGrading,
      cases,
      caseQuestions,
      selectedIndex,
      stopTimer,
      disableNavigationButtons,
    } = this.state;
    const { questionIndex = 0, caseIndex = 0 } = this.props.params;
    const { case_id, id } = caseQuestions[questionIndex];
    const { chapter_id } = cases[caseIndex];
    const data = {
      idname,
      token,
      caseId: case_id,
      questionIndex,
      questionId: id,
      chapterId: chapter_id,
      userGrading,
      multipleAnswer: selectedChoice,
      userJustification1: justification1,
      userJustification2: justification2,
    };
    const getQuestionIndex = this.attemptedQuestions.findIndex(
      element => element.questionId === id,
    );
    const dataset = {
      caseId: case_id,
      questionIndex,
      questionId: id,
      chapterId: chapter_id,
      userGrading,
      selectedChoice,
      selectedIndex,
      justification1,
      justification2,
      stopTimer,
      disableNavigationButtons,
    };
    if (getQuestionIndex === -1) {
      this.attemptedQuestions.push(dataset);
    } else this.attemptedQuestions[getQuestionIndex] = dataset;
    localStorage.setItem('attemptedQuestions', JSON.stringify(this.attemptedQuestions));
    // console.log('check the after selected grading', this.attemptedQuestions);
    await FD.callAPI(
      `${App_data.backend_api}/cfa3EssayQuestions/upsertQuestionsUserStats`,
      data,
    ).then(res => {
      if (res.success) {
        showSuccess('Grading updated.');
      }
    });
  };

  handleChange = event => {
    const { name, value } = event.target;
    this.setState(
      {
        [name]: value,
        disableNavigationButtons: false,
      },
      () => {
        if (name === 'userGrading') this.upsertQuestionUserStats();
      },
    );
  };

  _getResult = () => {
    const {
      state,
      props: {
        params: { questionIndex },
      },
    } = this;
    const {
      justification1,
      justification2,
      selectedChoice,
      caseQuestions,
      selectedIndex,
      stopTimer,
    } = state;
    const {
      id,
      case_id,
      is_multiple,
      development_justification,
      development_justification2,
    } = caseQuestions[questionIndex];
    let optionTypeCount = 0,
      answerTypeCount = 0;
    if (is_multiple === 1) optionTypeCount++;

    if (development_justification.trim()) optionTypeCount++;

    if (development_justification2.trim()) optionTypeCount++;

    if (justification1) answerTypeCount++;

    if (justification2) answerTypeCount++;

    if (selectedChoice) answerTypeCount++;

    if (optionTypeCount === answerTypeCount) {
      // if (
      //   (development_justification.trim() &&
      //     justification1.trim().length < 50) ||
      //   (development_justification2.trim() && justification2.trim().length < 50)
      // ) {
      //   this.setState({
      //     displayError: true,
      //     errorMessageOnValidate:
      //       'Justification should be greater than 50 characters',
      //   });
      //   return;
      // }
      this.setState({
        showResult: true,
        stopTimer: true,
        disableNavigationButtons: true,
      });

      const getQuestionIndex = this.attemptedQuestions.findIndex(
        element => element.questionId === id,
      );
      const dataset = {
        caseId: case_id,
        questionIndex,
        questionId: id,
        selectedChoice,
        selectedIndex,
        justification1,
        justification2,
        stopTimer,
        disableNavigationButtons: true,
      };
      if (getQuestionIndex === -1) {
        this.attemptedQuestions.push(dataset);
      }
    } else {
      // showFailure('Please answer all sections of a question.');
      this.setState({
        displayError: true,
        errorMessageOnValidate: 'Please answer all fields',
      });
    }
  };

  _saveQuestion = async (...questionIndex) => {
    const essayQuestionIndex = questionIndex['0'];
    const { idname, token, caseQuestions } = this.state;
    const {
      params: { chapterID },
    } = this.props;
    const isEssayQuestion = 1;
    const question_id = caseQuestions[essayQuestionIndex];
    const data = {
      idname,
      token,
      essayQuestionIndex,
      isEssayQuestion,
      question_id: question_id.id,
      chapter_id: chapterID,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      this.unSaveQuestion(data);
      return;
    }
    const saveQuestion = await FD.callAPI(
      `${App_data.backend_api}/cfa_3question_bank/saveQuestion`,
      data,
    );
    if (saveQuestion.success) {
      this.setState({ ValidToken: true });
      this.setState({
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      });
      this.setState({
        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
      });
      this.setState({ bookmarkColor: 'rgb(54, 141, 84)' });
      this.setState({ save_text: `${language.LC().Question_Saved}` });
    } else {
      this.setState({ ValidToken: false });
    }
  };
  //Function to show Report box
  _displayReportForm = () => {
    this.setState({ report_block: 'card show_block' });
  };
  _reportQuestion = (...item) => {
    const { id: question_id } = item['1'];
    const {
      params: { questionIndex, caseIndex },
    } = this.props;
    const comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    // const result = getDeviceDetails();
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id,
      comment,
      essayQuestionIndex: questionIndex,
      isEssayQuestion: 1,
      caseIndex,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    this.setState({
      reportLoading: true,
    });

    FD.callAPI(`${App_data.backend_api}/cfa_3question_bank/reportQuestion`, data).then(resp => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        // setState({ successAlert: true }) re-renders the report block into the
        // success view, which unmounts the textarea. By the time this line
        // ran the element was already gone, throwing
        //   TypeError: Cannot set properties of null (setting 'value')
        // and aborting the rest of the .then chain. The reset is purely
        // cosmetic (the textarea won't be visible again until the user
        // reopens the report form), so a null-guard is enough to silence the
        // error and let the promise resolve normally.
        const commentEl = document.getElementById('comment');
        if (commentEl) commentEl.value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };
  changeModelStatus = () => {
    this.setState({
      change_status: false,
    });
  };
  changeCase = () => {
    const {
      params: { chapterID, chapterName },
    } = this.props;
    localStorage.removeItem('attemptedQuestions');
    this.context.router.push({
      pathname: AppRoutes.CFA3_ESSAY_QUESTION_CASES.replace(':chapterID', chapterID).replace(
        ':chapterName',
        chapterName,
      ),
    });
  };

  onClose = () => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };
  //Function to hide Report box
  _hideReportForm = () => {
    this.setState({ report_block: 'card hide_block' });
  };
  render() {
    const { state, props } = this;
    const {
      showResult,
      caseQuestions,
      cases,
      displayLoader,
      justification1,
      justification2,
      selectedChoice,
      selectedIndex,
      displayError,
      displayQuestionLoader,
      stopTimer,
      userGrading,
      disableNavigationButtons,
      userStats,
      showComponent,
      showLoaderOnModel,
      changeStatusTitle,
      markAsCompleted,
      change_status,
      markAsNotCompleted,
      markCompleted,
      reportLoading,
      bookmarkCSS,
      bookmarkColor,
      errorMessageOnValidate,
    } = state;

    const { questionIndex = 0, caseIndex = 0, chapterName } = props.params;
    let questionData = {};
    let caseData = {};
    if (caseQuestions.length) {
      questionData = caseQuestions[questionIndex];
    }
    if (cases.length) {
      caseData = cases[caseIndex];
    }
    const questions_data_display = questionData;
    return (
      <div className='animated fadeIn'>
        <Heading headerText={chapterName}>
          <button
            className='btn btn-primary pointer_class'
            onClick={() => {
              this.changeCase();
            }}
          >
            Change Case
          </button>
        </Heading>
        <DisplayLoader displayLoader={displayLoader}>
          <ViewCase
            {...caseData}
            casesData={cases}
            caseIndex={caseIndex}
            getNextCase={this.getNextCase}
            getPreviousCase={this.getPreviousCase}
            disableNavigationButtons={disableNavigationButtons}
          />

          <DisplayLoader displayLoader={displayQuestionLoader}>
            <ViewQuestions
              {...questionData}
              caseQuestions={caseQuestions}
              attemptedQuestions={this.attemptedQuestions}
              questionIndex={questionIndex}
              getPreviousQuestion={this.getPreviousQuestion}
              getNextQuestion={this.getNextQuestion}
              setJustification={this.setJustification}
              setUserChoice={this.setUserChoice}
              justification1={justification1}
              justification2={justification2}
              selectedChoice={selectedChoice}
              selectedIndex={selectedIndex}
              displayError={displayError}
              stopTimer={stopTimer}
              disableNavigationButtons={disableNavigationButtons}
              errorMessageOnValidate={errorMessageOnValidate}
              showResult={showResult}
              all_questions={questionIndex}
              isQue={true}
              _getResult={this._getResult}
              _saveQuestion={this._saveQuestion}
              _displayReportForm={this._displayReportForm}
              save_text={language.LC().SAVE_QUESTION}
              bookmarkCSS={bookmarkCSS}
              bookmarkColor={bookmarkColor}
              questionData={questionData}
            />
            {/* {questionData && questionData.question && (
              <Row className='note-section note-section-new p-0 align-items-center'>
                <Col md='12' sm='12' className='p-0'>
                  <ValidateSaveReportIcon
                    all_questions={questionIndex}
                    isQue={true}
                    _getResult={this._getResult}
                    _saveQuestion={this._saveQuestion}
                    _displayReportForm={this._displayReportForm}
                    save_text={language.LC().SAVE_QUESTION}
                    bookmarkCSS={bookmarkCSS}
                    bookmarkColor={bookmarkColor}
                    className='p-0'
                    showResult={showResult}
                  />
                </Col>
              </Row>
            )} */}
          </DisplayLoader>
        </DisplayLoader>

        <div className='mb-2' />
        {showResult ? (
          <ViewAnswer
            {...questionData}
            handleChange={this.handleChange}
            selectedChoice={selectedChoice}
            userGrading={userGrading}
          />
        ) : null}
        <div className='row'>
          <div className='col-md-12'>
            <div className={this.state.report_block}>
              <div className='card-header'>
                {language.LC().REPORT}
                {/* <TooltipItem
                      key="1"
                      id="1"
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    /> */}
              </div>

              {!this.state.successAlert ? (
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-12 col-md-12'>
                      <label className='form-control-label' htmlFor='textarea-input'>
                        <strong> {language.LC().COMMENT}</strong>
                      </label>
                    </div>
                    <div className='col-sm-12 col-md-12 margin_bottom_10'>
                      <textarea
                        id='comment'
                        name='comment'
                        rows='6'
                        className='form-control'
                        placeholder='Content..'
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-sm-12 col-md-12'>
                      <button
                        type='button'
                        className='btn btn-primary active pointer_class report-btn'
                        disabled={reportLoading}
                        onClick={() => this._reportQuestion(this, questions_data_display)}
                      >
                        {' '}
                        {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                      </button>
                      <button
                        type='button'
                        className='btn btn-danger active pointer_class margin_left_10'
                        onClick={() => this._hideReportForm.bind(this, questions_data_display)}
                      >
                        {' '}
                        {language.LC().CANCEL}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-12 report-Success-card'>
                      <img src={`${App_data.frontend_url}/img/success-ic.svg`} alt='' />
                      <label className='form-control-label' htmlFor='textarea-input'>
                        <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                      </label>
                      <button
                        type='button'
                        className='btn btn-primary active pointer_class  min-vw-120'
                        onClick={this.onClose}
                      >
                        {' '}
                        {language.LC().CLOSE}
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <StatusChangeModel
          change_status={change_status}
          className={''}
          changeModelStatus={this.changeModelStatus}
          changeStatusTitle={changeStatusTitle}
          markAsCompleted={markAsCompleted}
          markNotCompleted={this.markNotCompleted}
          markAsNotCompleted={markAsNotCompleted}
          markCompleted={markCompleted}
          markCompletedFun={this.markCompleted}
          changeCompletionStatus={this.changeCompletionStatus}
          summaryDetails={userStats}
          showComponent={showComponent}
          showLoaderOnModel={showLoaderOnModel}
        />
      </div>
    );
  }
}

export default CaseQuestions;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/CaseQuestions.jsx